import { API_BASE_URL } from './config';
import { apiFetch, isNetworkError } from './helpers';
import type { ProverbResponse } from './types';

export async function fetchProverb(): Promise<void> {
    const textEl = document.getElementById('proverb-text');
    const btn = document.getElementById('new-proverb-btn') as HTMLButtonElement | null;

    if (!textEl || !btn) return;

    textEl.classList.add('fade');
    btn.disabled = true;

    try {
        const response = await apiFetch(`${API_BASE_URL}/proverb`);
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
        }

        const data: ProverbResponse = await response.json();

        await new Promise<void>((resolve) => setTimeout(resolve, 400));

        textEl.textContent = data.proverb;
    } catch (error) {
        if (!isNetworkError(error)) console.error('Failed to fetch proverb:', error);

        await new Promise<void>((resolve) => setTimeout(resolve, 400));
        textEl.textContent = 'The path to wisdom is sometimes blocked by clouds. Please try again.';
    } finally {
        textEl.classList.remove('fade');
        btn.disabled = false;
    }
}
